// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/ForgotPassword';
import { setForm, requestNewPassword } from '../../actions';
import { SET_NEW_PASSWORD_FORM } from '../../constants/forms';

type Props = {
    clientID: number,
    branding: Object,
    params: Object,
    auth: {
        language: string,
    },
    setForm: Function,
    requestNewPassword: Function,
};

type State = {
    name: String,
    active: boolean,
};

const validate = (values: Object) => {
    const errors = {};
    if (!values.email) {
        errors.email = 'Required';
    } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
        errors.email = 'Invalid email format';
    }

    return errors;
};

export class ForgotPassword extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    changeForm = (form: any) => {
        this.props.setForm(form);
    };

    requestNewPassword = ({ email }: Object) => {
        return this.props.requestNewPassword(
            email,
            this.props.clientID,
            this.changeForm(SET_NEW_PASSWORD_FORM)
        );
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const { branding, params, auth } = this.props;

        return (
            <Form
                changeForm={this.changeForm}
                onSubmit={this.requestNewPassword}
                branding={branding}
                params={params}
                lng={auth.language}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        clientID: state.paywall.clientID,
        branding: state.branding,
        params: state.form.forgotPassForm,
        auth: state.auth,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
        requestNewPassword,
    }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/Forms/ForgotPassword.js